$(document).ready(function () {
	$('.to-animate').addClass("is-animated");
	
	$('.s-carousel').slick({
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 3000,
		mobileFirst: true,
		adaptiveHeight: true,
		touchThreshold: 10
	});
	
	$('.cat-tag-carousel').slick({
		dots: false,
		arrows: false,
		infinite: false,
		autoplay: false,
		autoplaySpeed: 3000,
		mobileFirst: true,
		adaptiveHeight: true,
		centerMode: false,
		variableWidth: true,
		touchThreshold: 30
	});
	
	
	$('.media-carousel').slick({
		dots: false,
		arrows: false,
		infinite: false,
		slidesToShow: 1.1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		mobileFirst: true,
		adaptiveHeight: true,
		touchThreshold: 10,
		centerMode: false,
		
		responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						centerMode: true,
						infinite: true,
					}
				},
			]
	});
	



	$('[data-carousel-id]').each(function () {
		
		let $carousel = $(this);
		let carouselId = $carousel.data('carousel-id');
		let carouselStyle = $carousel.data('carousel-style');
		
		
		
		
		
		
		
		let coldef = 4;
		let sts_min = 1;
		//let sts_min = 1.2; //VOIR A2Q5-T261
		
		if (carouselStyle == "simple") {
			coldef = 5;
			sts_min = 1;
			//sts_min = 1.5; //VOIR A2Q5-T261
		}

		let $backBtn = $('[data-carousel-for="' + carouselId + '"].back-btn');
		let $nextBtn = $('[data-carousel-for="' + carouselId + '"].next-btn');

		// Compter le nombre d'items
		let itemCount = $carousel.children().length;

		// Déterminer si infinite doit être désactivé
		let initialSlidesToShow = sts_min;
		let forceNoInfinite = itemCount < initialSlidesToShow;

		// Attache les événements AVANT l'initialisation
		$carousel.on('init', function (event, slick) {
			updateButtons(slick.currentSlide, slick);
		});

		$carousel.on('afterChange', function (event, slick, currentSlide) {
			updateButtons(currentSlide, slick);
		});

		// Fonction pour mettre à jour l'état des boutons
		function updateButtons(currentSlide, slick) {
			let slickObj = slick || $carousel.slick('getSlick');

			// Désactive si au début
			
			if (currentSlide === 0) {
				$backBtn.prop('disabled', true).addClass('disabled');
			} else {
				$backBtn.prop('disabled', false).removeClass('disabled');
			}

			// Désactive si à la fin
			if (currentSlide >= slickObj.slideCount - slickObj.options.slidesToShow) {
				$nextBtn.prop('disabled', true).addClass('disabled');
			} else {
				$nextBtn.prop('disabled', false).removeClass('disabled');
			}
			
		}

		// Initialise Slick
		$carousel.slick({
			dots: false,
			arrows: false,
			infinite: false, // <<< LE POINT IMPORTANT
			//slidesToShow: Math.min(sts_min, itemCount), // évite un slide vide
			slidesToShow: 1, 
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 3000,
			mobileFirst: true,
			adaptiveHeight: true,
			centerMode: false,
			responsive: [
				{
					breakpoint: 768,
					settings: function () {
						let show = Math.min(3, itemCount);
						return {
							//slidesToShow: show,
							slidesToShow: 3,
							infinite: false,
							//infinite: itemCount > show,
							centerMode: false,
						};
					}()
				},
				{
					breakpoint: 1200,
					settings: function () {
						let show = Math.min(coldef, itemCount);
						return {
							//slidesToShow: show,
							slidesToShow: 4,
							infinite: false,
							//infinite: itemCount > show,
							centerMode: false,
						};
					}()
				}
			]
		});

		// Gérer les boutons associés à ce carrousel
		$backBtn.on('click', function () {
			$carousel.slick('slickPrev');
		});
		$nextBtn.on('click', function () {
			$carousel.slick('slickNext');
		});
	});


});
